// Shared local date/time formatting, capturing the pattern used across the
// Remote Diagnostics screens (2-digit fields, 24-hour, comma stripped).
// New screens import this instead of re-inlining the same toLocaleString call.

const DEFAULT_OPTS = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
};

/**
 * Format a date/timestamp the way the portal's session tables do.
 * Accepts a Date, epoch ms, or anything the Date constructor understands.
 * Returns '' for missing/invalid input.
 */
export const formatLocalDateTime = (value, opts = DEFAULT_OPTS) => {
  if (value === null || value === undefined || value === '') return '';
  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleString(undefined, opts).replace(',', '');
};

/** Format a UTC timestamp in the viewer's local timezone, including its abbreviation. */
export const formatLocalDateTimeWithZone = (value) =>
  formatLocalDateTime(value, { ...DEFAULT_OPTS, timeZoneName: 'short' });

/**
 * Format an elapsed duration (in seconds) as "M:SS" — used by the live
 * session elapsed-time counter.
 */
export const formatElapsed = (totalSeconds) => {
  const s = Math.max(0, Math.floor(totalSeconds || 0));
  const mins = Math.floor(s / 60);
  const secs = s % 60;
  return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
};
